import React, { useState, useEffect, useContext } from "react";
import { Navigation, Autoplay, EffectCoverflow } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "antd";
import HotList from "../components/HotList";
import LatestList from "../components/LatestList";
import "swiper/scss";
import "swiper/css/effect-coverflow";
import "swiper/scss/autoplay";
import "swiper/scss/navigation";
import "./styles/scss/Wjyz.scss";
import {
	CTX_STATE,
	Request,
	catchErrorHandle,
	specialNavigate,
	protypeObj,
} from "../common";

export default function App() {
	const navigate = useNavigate();
	const _state = useContext(CTX_STATE);

	const [pageBtn, setPageBtn] = useState(true);
	const [hotNav, setHotNav] = useState("游戏账号");
	const [hotList, setHotList] = useState([]);
	const [bannerList, setBannerList] = useState([]);
	const [newList, setNewList] = useState([]);

	useEffect(() => {
		const req = new Request({
			url: "/product-query-center/product-query/product/getRotationProducts",
			source: 1,
			data: {
				cid: 6,
			},
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.code === 200) {
					setBannerList(res.data ?? []);
				}
			} catch (error) {
				console.log(catchErrorHandle(error));
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, []);

	useEffect(() => {
		const req = new Request({
			url: "/open-platform/pro/productInfoSortWjyz",
			source: 1,
			data: {
				protype: protypeObj[hotNav], //充值卡筛选包含了会员卡密
				sortname: "sale",
				cur: 1,
				size: 20,
			},
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.code === 200) {
					setHotList(res.data?.data ?? []);
				}
			} catch (error) {
				console.log(catchErrorHandle(error));
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [hotNav]);

	useEffect(() => {
		const req = new Request({
			url: "/open-platform/pro/productInfoSortWjyz",
			source: 1,
			data: {
				protype: 1,
				sortname: "newpro",
				cur: 1,
				size: 10,
			},
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.code === 200 && res.data?.data) {
					setNewList(res.data.data);
				}
			} catch (error) {
				console.log(catchErrorHandle(error));
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, []);

	const defaultConfig = (ele) => {
		if (ele === hotNav) return;

		setHotList([]); //处理接口延迟列表显示错误问题
	};

	return (
		<>
			<div className="wjyz-banner">
				{bannerList.length ? (
					<>
						<Swiper
							modules={[EffectCoverflow, Autoplay, Navigation]}
							autoplay={true}
							loop={true}
							loopedSlides={15}
							effect="coverflow"
							initialSlide={2}
							slidesPerView="auto"
							centeredSlides={true}
							coverflowEffect={{
								rotate: 0,
								stretch: 560,
								depth: 300,
								modifier: 1,
								slideShadows: true,
							}}
							navigation={{
								prevEl: ".wjyz-latest-prev",
								nextEl: ".wjyz-latest-next",
							}}
							onTransitionStart={() => {
								setPageBtn(false);
							}}
							onTransitionEnd={() => {
								setPageBtn(true);
							}}
						>
							{bannerList.map((ele, index) => {
								return (
									<SwiperSlide
										key={index}
										style={{
											backgroundImage: `url(https://cdn-wjyz.wanjiayizhan.com${encodeURI(
												ele.pimg
											)})`,
										}}
										onClick={() => {
											specialNavigate(
												"/Goods",
												_state.token,
												navigate,
												true,
												ele
											);
										}}
									></SwiperSlide>
								);
							})}
						</Swiper>
						<button
							type="button"
							className={`wjyz-latest-prev${pageBtn ? " active" : ""}`}
						>
							&lt;
						</button>
						<button
							type="button"
							className={`wjyz-latest-next${pageBtn ? " active" : ""}`}
						>
							&gt;
						</button>
					</>
				) : (
					<Skeleton.Image active style={{ width: 1217, height: 286 }} />
				)}
			</div>

			<div className="wjyz-type">
				{[...new Array(4)].map((ele, index) => {
					return (
						<button
							type="button"
							key={index}
							onClick={() => {
								specialNavigate("/AllGame", _state.token, navigate, true, {
									index: index + 1,
								});
							}}
						>
							{ele}
						</button>
					);
				})}
			</div>

			<div className="main" style={{ height: 352, marginTop: 12 }}>
				<div className="wjyz">
					<div className="hot">
						<div className="title">
							<div className="left">
								<div></div>畅销榜单
							</div>
							<div className="right">
								{Object.keys(protypeObj).map((ele, index) => {
									return (
										<React.Fragment key={index}>
											<button
												type="button"
												className={hotNav === ele ? "active" : ""}
												onClick={() => {
													defaultConfig(ele);
													setHotNav(ele);
												}}
											>
												{ele}
											</button>
										</React.Fragment>
									);
								})}
							</div>
						</div>

						{hotList.length ? (
							<HotList from="wjyz" list={hotList} nav={1} />
						) : (
							<div className="content">
								{[...new Array(20)].map((ele, index) => {
									return <Skeleton.Avatar key={index} active shape="square" />;
								})}
							</div>
						)}
					</div>

					<div className="latest">
						<div className="title">
							<div className="left">
								<div></div>最新上架
							</div>
						</div>
						{newList.length ? (
							<LatestList from="wjyz" list={newList} />
						) : (
							<Skeleton.Input active style={{ width: 1202, height: 152 }} />
						)}
					</div>
				</div>
			</div>
		</>
	);
}
